export const schedule_transaction_id = (state) => {
  return state.transaction_id;
};

export const transaction_result = (state) => {
  return state.transaction_result;
};
